import { FC, useMemo } from 'react';
import { Button } from '@storybook';
import Tippy from '@tippyjs/react';
import { IClientEmail } from 'views/email-client/stores';
import { ClientItem } from './ClientItem';
import { PERMISSION_SCREEN, useUserRoles } from 'views/routes-children';

interface SettingsViewProps {
	emailClientsList: IClientEmail[];
	handleClick: () => void;
	getDropOptions: (client: IClientEmail) => any[];
}

export const SettingsView: FC<SettingsViewProps> = ({
	emailClientsList,
	handleClick,
	getDropOptions,
}) => {
	const { checkUserWritePermission } = useUserRoles();
	
	const isUserPermissionWrite = useMemo(
		() => checkUserWritePermission(PERMISSION_SCREEN.GeneralSettings),
		[checkUserWritePermission]
	);
	return (
		<>
			<div className="connected-client_wrapper">
				<div className="connected-client_header-wrapper">
					<div className="connected-client_logo header-logo">
						<i className="ri-mail-fill"></i>
					</div>
					<div className="connected-client_info-content">
						<div className="connected-client_title">
							<span>Email Client</span>
							{emailClientsList.length > 0 && (
								<Tippy
									disabled={isUserPermissionWrite}
									content="You are not permitted to add email client"
								>
									<div>
										<Button
											handleClick={handleClick}
											label={'Add email client'}
											type="button__outline btn-change-email-client"
											disabled={!isUserPermissionWrite}
										/>
									</div>
								</Tippy>
							)}
						</div>
						<div className="connected-client_subtitle">
							The email client is used to send invites for the onboarding flows.
						</div>
					</div>
				</div>
			</div>
			
			{emailClientsList.length > 0 && <div className="connected-client_info-container">
				<div className="connected-client_info-note">
					<i className="ri-information-line connected-client_info-icon"></i>
					<div className="connected-client_info-text">
						<strong>Note:</strong> Changing the default email will not affect the email client already used in existing onboarding flows.
					</div>
				</div>
			</div>}
		
		{emailClientsList.length === 0 ? (
			<Tippy
				disabled={isUserPermissionWrite}
				content="You are not permitted to add email client"
			>
				<div>
					<Button
						handleClick={handleClick}
						label={'Add your email client'}
						type="button__filled button__filled--secondary btn-add-email-client"
						disabled={!isUserPermissionWrite}
					/>
				</div>
			</Tippy>
		) : (
				<div className="connected-client_wrapper-setting-list">
					{emailClientsList.map(client => (
						<ClientItem
							key={client._id}
							client={client}
							showDropdown={true}
							dropOptions={getDropOptions(client)}
							className="connected-client_wrapper-setting"
						/>
					))}
				</div>
			)}
		</>
	);
}; 